import { Combobox } from '@/components/common/Combobox'
import { useTaskActionTypes } from '../hooks'
import { iconForActionType } from './actionTypeIcons'

interface Props {
  value: string | null
  onChange: (code: string | null) => void
  className?: string
  /** Gdy true, etykietki są w długiej formie z ikoną; w drawerze i kanban chip wystarcza krótka. */
  showPlaceholder?: boolean
}

/** Combobox typu akcji dla taska. Pełne listy są krótkie (5-10 typów),
 *  więc search ukryty (threshold 8). Prefix slot pokazuje ikonę per typ akcji. */
export function ActionTypeSelect({ value, onChange, className, showPlaceholder = true }: Props) {
  const { data: types = [], isLoading } = useTaskActionTypes()

  const options = types.map((t) => {
    const Icon = iconForActionType(t.code)
    return {
      value: t.code,
      label: t.label,
      prefix: <Icon className="size-3.5 shrink-0 text-slate-500" />,
    }
  })

  return (
    <Combobox<string>
      value={value}
      onChange={onChange}
      options={options}
      placeholder={showPlaceholder ? '-- wybierz typ --' : undefined}
      emptyOptionLabel={showPlaceholder ? '-- bez typu --' : undefined}
      disabled={isLoading}
      className={className}
    />
  )
}
